import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import CartSidebar from "../CartSidebar/CartSidebar";

const Header = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <header className="crazy-header">
      <div className="header-container">
        <div className="logo">
          <Link to="/"> <span>Auto</span>Pro</Link>
        </div>

        {!isCartOpen && (
          <div className="cart-icon" onClick={() => setIsCartOpen(true)}>
            🛒
          </div>
        )}
      </div>

      <div className="summer-banner">
        🔥 מבצעי קיץ חסרי תקדים! 🔥
      </div>

      {isCartOpen && <CartSidebar onClose={() => setIsCartOpen(false)} position="left" />}
    </header>
  );
};

export default Header;
